export * from './a2t-form/a2t-form.service';
export * from './a2t-shared.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/angular2-token/lib/a2t-ui/a2t-shared/index.js
// module id = ../../../../angular2-token/lib/a2t-ui/a2t-shared/index.js
// module chunks = 3